module.exports = __webpack_public_path__ + "static/media/estructura_bco.7590bd94.svg";